import React from 'react';

import { getUrlSync, ICoreContext } from '@msdyn365-commerce/core';

import { ICusWishlistResources } from '../../cus-wishlist.props.autogenerated';
import Button from '../../../../components/custom/button';
import { PAGE_NAMES } from '../../../../shared/const/page-names';
import { WishlistFallbackStateTemplate } from '../wishlist-fallback-state-template/wishlist-fallback-state-template';

interface Props {
    resources: ICusWishlistResources;
    context: ICoreContext;
}

export const EmptyWishlist = ({ resources, context }: Props) => {
    const exploreHref = getUrlSync(PAGE_NAMES.HOME, context.actionContext) ?? context.request.sitePath ?? '/';

    return (
        <WishlistFallbackStateTemplate
            showIcon
            heading={resources.emptyWishlistText}
            description={resources.emptyWishlistDescriptionText}
            testId='wishlist-empty-message'
        >
            <Button mode='anchor' href={exploreHref}>
                {resources.emptyWishlistExploreButtonText}
            </Button>
        </WishlistFallbackStateTemplate>
    );
};
